import { render, staticRenderFns } from "./MemberAskHistory.vue?vue&type=template&id=045775b5&"
import script from "./MemberAskHistory.vue?vue&type=script&lang=js&"
export * from "./MemberAskHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('045775b5')) {
      api.createRecord('045775b5', component.options)
    } else {
      api.reload('045775b5', component.options)
    }
    module.hot.accept("./MemberAskHistory.vue?vue&type=template&id=045775b5&", function () {
      api.rerender('045775b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/members/member-manage/MemberAskHistory.vue"
export default component.exports